export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/applications', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/application', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/application/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/application/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/application/' + data.id, { params: data.filters || {} })
  }
})
